import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useCallback, useMemo, useEffect, Fragment } from 'react';
import '../../../../contexts/MenuContext/index.mjs';
import '../../../../contexts/MicrositeMenuContext/index.mjs';
import { useMicrositeMenuTranslations } from '../../../../contexts/MicrositeMenuContext/translations.mjs';
import './assets/arrow-icon-tertiary.svg.mjs';
import { Wrap, TopologyHeader, StyledArrowIcon, SectionTitle, MainCards, MainCard, CardLabel, CardDescription, ChildCards, Column, ChildCard, CardIcon, ChildChildCard, ChildTreeBranch } from './SiteMapColumns.styles.mjs';
import { useMicrositeMenu } from '../../../../contexts/MicrositeMenuContext/context.mjs';
import { useMenu } from '../../../../contexts/MenuContext/context.mjs';
import ArrowIconTertiary__default from "../../../../assets/arrow-icon-tertiary.svg";
"use strict";
const SiteMapColumns = ({
  items,
  onLinkClick
}) => {
  const {
    language
  } = useMicrositeMenu();
  const {
    formatMessage
  } = useMicrositeMenuTranslations(language);
  const {
    createSiteUrl
  } = useMenu();
  const [isSitemapExpanded, setIsSitemapExpanded] = useState(true);
  const [activeHoverItemId, setActiveHoverItemId] = useState(null);
  const siteMapRef = useRef(null);
  const childCardRefs = useRef({});
  const childSubCardRefs = useRef({});
  const [childCardBranchHeights, setChildCardBranchHeights] = useState(/* @__PURE__ */new Map());
  const recalculateBranchHeights = useCallback(() => {
    const heights = /* @__PURE__ */new Map();
    Object.entries(childCardRefs.current).forEach(([key, value]) => {
      if (value?.offsetParent) {
        heights.set(key, getHeight(value));
      }
    });
    Object.entries(childSubCardRefs.current).forEach(([key, value]) => {
      if (value?.offsetParent) {
        heights.set(key, getHeight(value));
      }
    });
    setChildCardBranchHeights(heights);
  }, []);
  const getOverviewUrl = item => {
    const [overview] = item?.items ?? [];
    if (!overview) {
      return void 0;
    }
    return createSiteUrl(overview.url);
  };
  const childBranchLineHeight = useMemo(() => Math.max(...Array.from(childCardBranchHeights.values())), [childCardBranchHeights]);
  const getHeight = element => {
    const parentOffsetTop = element?.offsetParent?.getBoundingClientRect()?.top ?? 0;
    return element.getBoundingClientRect().top - parentOffsetTop + 20 + element.clientHeight / 2;
  };
  const onHandleLinkClick = (event, url) => {
    if (url) {
      onLinkClick(event, createSiteUrl(url));
    }
  };
  const isMainCardActive = item => {
    return (item?.items ?? [])?.some(({
      id,
      items: items2
    }) => id === activeHoverItemId || items2?.some(({
      id: subId
    }) => subId === activeHoverItemId));
  };
  useEffect(() => {
    recalculateBranchHeights();
    window.addEventListener("resize", recalculateBranchHeights);
    return () => {
      window.removeEventListener("resize", recalculateBranchHeights);
    };
  }, [recalculateBranchHeights]);
  return /* @__PURE__ */jsxs(Wrap, {
    ref: siteMapRef,
    children: [/* @__PURE__ */jsxs(TopologyHeader, {
      onClick: () => setIsSitemapExpanded(!isSitemapExpanded),
      children: [/* @__PURE__ */jsx(StyledArrowIcon, {
        src: ArrowIconTertiary__default,
        width: 14,
        height: 14,
        $isOpen: isSitemapExpanded
      }), /* @__PURE__ */jsx(SectionTitle, {
        children: formatMessage("menu.siteMap.title")
      })]
    }), /* @__PURE__ */jsx(MainCards, {
      children: items?.map(item => /* @__PURE__ */jsxs(MainCard, {
        $isActive: isMainCardActive(item),
        href: getOverviewUrl(item),
        onClick: event => onHandleLinkClick(event, item.url),
        children: [/* @__PURE__ */jsx(CardLabel, {
          children: formatMessage(item.label)
        }), !!item?.description && /* @__PURE__ */jsx(CardDescription, {
          dangerouslySetInnerHTML: {
            __html: formatMessage(item.description)
          }
        })]
      }, item.id))
    }), /* @__PURE__ */jsx(ChildCards, {
      $isVisible: isSitemapExpanded,
      children: items?.map(item => /* @__PURE__ */jsxs(Column, {
        children: [(item?.items ?? []).filter(({
          isOverview
        }) => !isOverview).map(subItem => /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsxs(ChildCard, {
            ref: ref => {
              childCardRefs.current[subItem.id] = ref;
            },
            onMouseEnter: () => setActiveHoverItemId(subItem.id),
            onMouseLeave: () => setActiveHoverItemId(null),
            onClick: event => onHandleLinkClick(event, subItem.url),
            children: [!!subItem?.icon && /* @__PURE__ */jsx(CardIcon, {
              src: subItem.icon.src,
              $height: subItem.icon.height,
              $width: subItem.icon.width,
              alt: "icon"
            }), /* @__PURE__ */jsx(CardLabel, {
              children: formatMessage(subItem.label)
            }), !!subItem?.description && /* @__PURE__ */jsx(CardDescription, {
              dangerouslySetInnerHTML: {
                __html: formatMessage(subItem.description)
              }
            })]
          }), !!subItem.items?.length && subItem.items?.map(item2 => /* @__PURE__ */jsxs(ChildChildCard, {
            ref: ref => {
              childSubCardRefs.current[item2.id] = ref;
            },
            onMouseEnter: () => setActiveHoverItemId(item2.id),
            onMouseLeave: () => setActiveHoverItemId(null),
            onClick: event => onHandleLinkClick(event, item2.url),
            children: [!!item2?.icon && /* @__PURE__ */jsx(CardIcon, {
              src: item2.icon.src,
              $height: item2.icon.height,
              $width: item2.icon.width,
              alt: "icon"
            }), /* @__PURE__ */jsx(CardLabel, {
              children: formatMessage(item2.label)
            })]
          }, item2.id))]
        }, subItem.id)), /* @__PURE__ */jsxs(ChildTreeBranch, {
          width: "20",
          height: childBranchLineHeight,
          $height: childBranchLineHeight,
          children: [item.items?.map(subItem => /* @__PURE__ */jsxs(Fragment, {
            children: [/* @__PURE__ */jsx("path", {
              d: `M 1,0 V ${(childCardBranchHeights.get(subItem.id) ?? 0) - 9} a 9,9 0 0 0 9,9 H 8`,
              stroke: "#e7e7e7",
              strokeWidth: "1",
              fill: "none"
            }), subItem?.items?.map(item2 => /* @__PURE__ */jsx(Fragment, {
              children: /* @__PURE__ */jsx("path", {
                d: `M 1,0 V ${(childCardBranchHeights.get(item2.id) ?? 0) - 9} a 9,9 0 0 0 9,9 H 20`,
                stroke: "#e7e7e7",
                strokeWidth: "1",
                fill: "none"
              })
            }, `${item2.id}-sub-line-background`))]
          }, `${subItem.id}-background`)), item.items?.map(subItem => /* @__PURE__ */jsxs(Fragment, {
            children: [/* @__PURE__ */jsx("path", {
              d: `M 1,0 V ${(childCardBranchHeights.get(subItem.id) ?? 0) - 9} a 9,9 0 0 0 9,9 H 8`,
              stroke: "#3A95FF",
              strokeWidth: "2",
              fill: "none",
              style: {
                transition: "opacity 0.2s ease-in-out",
                opacity: activeHoverItemId === subItem.id ? 1 : 0,
                zIndex: 1e3
              }
            }), subItem?.items?.map(item2 => /* @__PURE__ */jsx(Fragment, {
              children: /* @__PURE__ */jsx("path", {
                d: `M 1,0 V ${(childCardBranchHeights.get(item2.id) ?? 0) - 9} a 9,9 0 0 0 9,9 H 20`,
                stroke: "#3A95FF",
                strokeWidth: "2",
                fill: "none",
                style: {
                  transition: "opacity 0.2s ease-in-out",
                  opacity: activeHoverItemId === item2.id ? 1 : 0,
                  zIndex: 1e3
                }
              })
            }, `${item2.id}-sub-line-active`))]
          }, `${subItem.id}-active`))]
        })]
      }, item.id))
    })]
  });
};
export { SiteMapColumns };
//# sourceMappingURL=SiteMapColumns.mjs.map
